export default __webpack_public_path__ + "static/media/cross-9-light.bf7637ab.svg";